if (!window.Eurus.loadedScript.has('quantity-selector.js')) {
  window.Eurus.loadedScript.add('quantity-selector.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xQuantitySelector', (
        productId,
        sectionId,
        qtyRuleMin,
        qtyRuleMax,
        isQtyRule,
        currencyCodeEnable,
        moneyWithCurrency,
        moneyFormat
      ) => ({
        qty: qtyRuleMin,
        min: qtyRuleMin,
        max: qtyRuleMax,
        initQtyChangeEvent(selector) {
          this.$nextTick(() => {
            this.qty = document.getElementById(selector)?.value;
            document.addEventListener(`eurus:product:quantity-changed-${sectionId}`, (e) => {
              this.qty = e.detail.quantity;
              this.updatePrice();
            });
            document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, () => {
              this.updatePrice();
            });
            document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, () => {
              this.updatePrice();
            });
          });
        },
        minus(value) {
          if(this.qty <= this.min) {
            this.qty = this.min;
          } else {
            this.qty = parseInt(this.qty);
            (this.qty == 1) ? this.qty = 1 : this.qty -= value;
          }
          this.updatePrice();
        },
        plus(value) {
          if(this.qty >= this.max && isQtyRule) {
            this.qty = parseInt(this.max);
          } else {
            this.qty = parseInt(this.qty);
            this.qty += value;
          }
          this.updatePrice();
        },
        invalid(el) {
          number = parseFloat(el.value);
          if (!Number.isInteger(number) || number < this.min) {
            this.qty = this.min;
          }
          if (number > this.max && isQtyRule) {
            this.qty = parseInt(this.max);
          }
          this.updatePrice();
        },
        updatePrice() {
          const product_template = document.getElementById(`x-product-template-${productId}-${sectionId}`);
          const money_format = currencyCodeEnable ? moneyWithCurrency : moneyFormat;

          const readNumber = (selector) => {
            return Number(product_template.querySelector(selector)?.innerHTML);
          };
          const update = (selector, value) => {
            const el = product_template.querySelector(selector);
            if (el) el.innerHTML = value;
          };

          const basePrice = readNumber('.target-price');
          const compareAtPrice = readNumber('.target-compare-at-price');

          let quantityPriceBreaks = [];
          try {
            quantityPriceBreaks = JSON.parse(product_template.querySelector('.target-quantity-price-breaks')?.innerHTML) || [];
          } catch (e) {
            quantityPriceBreaks = [];
          }

          let effectivePrice = basePrice;
          quantityPriceBreaks.forEach((priceBreak) => {
            if (this.qty >= priceBreak.minimum_quantity) {
              effectivePrice = priceBreak.price;
            }
          });

          let product_price = Alpine.store('xHelper').formatMoney(effectivePrice * this.qty, money_format);
          let product_compare_at_price = Alpine.store('xHelper').formatMoney(compareAtPrice * this.qty, money_format);

          update('.add_to_cart_button .main-product-price .price', product_price);
          update('.add_to_cart_button .main-product-price .price-sale', product_price);
          update('.add_to_cart_button .main-product-price .price-compare', product_compare_at_price);

          document.dispatchEvent(new CustomEvent(`quantity:changed-${sectionId}`, {
            detail: {
              qty: this.qty
            }
          }));            
        },
      }));
    })
  });
}    